<template>
    <div class="row">
        <b-card no-body class="col-12">
            <b-form @submit="onSubmit">
                <div class="row">
                    
                    <Label label="Código:" v-if="form.id" class="col-12" :value="form.id" icon="key" />
                    <Label label="Criado por:" v-if="form.id" class="col-6" :value="form.criador" icon="person" />
                    <Label label="Modificado por:" v-if="form.id" class="col-6" :value="form.modificador" icon="person" />
                    <Label label="Data e hora da criação:" v-if="form.id" class="col-6" :value="form.dataCriacao" icon="person" />
                    <Label label="Data e hora da modificação:" v-if="form.id" class="col-6" :value="form.dataModificacao" icon="person" />
                    
                    

                    <input-select class="col-12 mt-3" label="Tema:" :options="options.temas" v-model="form.temaSelecionado.temaId" ref="tema" required />
                    <div class="col-12">
                        <input-textarea  v-model="form.temaSelecionado.descricaoPersonalizada" :max-length="200" v-if="(form.temaSelecionado.temaId ? options.temas.find(el => el.value == form.temaSelecionado.temaId).text : '') == 'Outros'" ref="outroTema" required label="Outros temas" no-label/>
                    </div>

                    <input-select class="col-12 mt-3" label="Sub-tema:" :options="options.subtemas" v-model="form.subtemaSelecionado.subtemaId" ref="subtema" required />
                    <div class="col-12">
                        <input-textarea  v-model="form.subtemaSelecionado.descricaoPersonalizada" :max-length="200" v-if="(form.subtemaSelecionado.subtemaId ? options.subtemas.find(el => el.value == form.subtemaSelecionado.subtemaId).text : '') == 'Outros'" ref="outroSubtema" required label="Outros subtemas" no-label/>
                    </div>
                    
                    <div class="col-12 mt-3">
                        <input-textarea label="Descrição:"  v-model="form.descricao" ref="descricao" required/>
                    </div>

                    <div class="col-12 mt-3">
                        <input-textarea label="Área de interesse:"  v-model="form.areaDeInteresse" ref="areaInteresse" required/>
                    </div>
                    
                    <div class="col-12 mt-3">
                        <input-textarea label="Aplicação no mercado:"  v-model="form.aplicacaoNoMercado" ref="aplicacaoMercado" required/>
                    </div>

                    <div class="col-12 mt-3">
                        <h5>Idealizador(a)</h5>
                    </div>

                    <input-text label="Nome" class="col-12 col-md-4" v-model="form.solicitante.nome" ref="solicitante" />
                    <input-text label="E-mail" class="col-12 col-md-4" v-model="form.solicitante.email" ref="email" :type="(form.solicitante.email ? 'email' : 'text')"/>
                    <input-text label="Setor da empresa" class="col-12 col-md-4" v-model="form.solicitante.setorDaEmpresa" ref="setor" />
        
                    <div class="col-12 d-flex" v-if="(form.id ? form.empresaId == selectedCompany: true)">
                        <b-button variant="success" type="submit" class="mr-2" v-if="form.id ? permissao.u : permissao.c">
                            <i class="fa-solid fa-check mr-2"></i>
                            Salvar
                        </b-button>
                    </div>
                </div>
            </b-form>
        </b-card>
    </div>
</template>

<script>
import Label from "@/components/inputs/Label";
import InputSelect from "@/components/inputs/InputSelect";
import InputText from "@/components/inputs/InputText";
import InputTextarea from "@/components/inputs/InputTextarea";

import Swal from "sweetalert2";

import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";
import { START_LOADING, STOP_LOADING } from "@/store/Store";

import InfosService from "@/common/services/infos/infos.service";
import DemandaService from "@/common/services/demanda/demanda.service";

import helpers from "@/common/utils/helpers";

export default {
    props: ['id'],
    components: {
        Label,
        InputSelect,
        InputText,
        InputTextarea

    },
    data : () =>({
        form : {
            id : null,
            /*temaId : null,
            descricaoTema : "",
            subtemaId : null,
            descricaoSubtema : "",*/

            temaSelecionado: {
                temaId: null,
                descricaoPersonalizada: null
            },
            subtemaSelecionado: {
                subtemaId: null,
                descricaoPersonalizada: null
            },

            descricao : null,
            areaDeInteresse: null,
            aplicacaoNoMercado: null,
            solicitante : {
                nome : null,
                email : null,
                setorDaEmpresa : null,
            },

            criador: null,
            dataCriacao: null,
            modificador: null,
            dataModificacao: null,

            empresaId: null,
        },
        

        options: {
            temas: [],
            subtemas: []
        }
    }),
    methods : {
        validateState: function() {
            
            let arValidation = [];

            for (let ref in this.$refs) {
                
                arValidation.push(this.$refs[ref].valid());
            }
           
            return arValidation.filter((elem) => elem == false).length == 0;
        },
        
        onSubmit(e){
            e.preventDefault();

            Swal.fire({
                title: "Aviso",
                text: "Deseja salvar a demanda?",
                icon: "warning",
                showDenyButton: true,
                confirmButtonText: 'Sim',
                denyButtonText: `Não`
            }).then((result) =>{
                if (result.isConfirmed) {

                    if (this.validateState() == false) return;

                    this.$store.dispatch(START_LOADING);

                    if(!this.form.id)
                        this.form.empresaId = this.selectedCompany;

                    if(!this.form.empresaId){
                        Swal.fire({
                            title: "Aviso",
                            text: "Não foi possível identificar a empresa, por favor, selecione uma empresa no menu lateral.",
                            icon: "error"
                        });

                        this.$store.dispatch(STOP_LOADING);
                        return false;
                    }

                    DemandaService.store(this.form).then(() => {

                        Swal.fire({
                            title: "Sucesso",
                            text: "Demanda salva com sucesso!",
                            icon: "success",
                        }).then(() =>{
                            this.$router.push({ name: "demanda-lista" });
                        });
                        
                    }).catch(() => {

                        Swal.fire({
                            title: "Erro",
                            text: "Ocorreu um erro ao salvar a demanda",
                            icon: "error",
                            confirmButtonText: "Ok"
                        });

                    }).finally(() => {
                        this.$store.dispatch(STOP_LOADING);
                    });

                } 
            });
            
        },

        

        fetchDemanda: function(id){
            this.$store.dispatch(START_LOADING);

            DemandaService.get(id).then(response  => {
                
                this.form.id = id
                this.form.temaSelecionado.temaId = response.data.data.temaSelecionado.tema.id;
                this.form.temaSelecionado.descricaoPersonalizada = response.data.data.temaSelecionado.descricaoPersonalizada;
                this.form.subtemaSelecionado.subtemaId = response.data.data.subtemaSelecionado.subtema.id;
                this.form.subtemaSelecionado.descricaoPersonalizada = response.data.data.subtemaSelecionado.descricaoPersonalizada;
                this.form.descricao = response.data.data.descricao;
                this.form.areaDeInteresse = response.data.data.areaDeInteresse;
                this.form.aplicacaoNoMercado = response.data.data.aplicacaoNoMercado;
                this.form.solicitante.nome = response.data.data.solicitante.nome;
                this.form.solicitante.email = response.data.data.solicitante.email;
                this.form.solicitante.setorDaEmpresa = response.data.data.solicitante.setorDaEmpresa;

                this.form.criador = (response.data.data.criador.pessoa ? 
                                        response.data.data.criador.pessoa.nome :
                                        response.data.data.criador.nomeUsuario);

                this.form.dataCriacao = helpers.formatarDataBr(response.data.data.dataCriacao, true);

                this.form.modificador = (response.data.data.modificador ? (response.data.data.modificador.pessoa ? 
                                        response.data.data.modificador.pessoa.nome :
                                        response.data.data.modificador.nomeUsuario) : null);

                this.form.dataModificacao = (response.data.data.modificador ? 
                                                helpers.formatarDataBr(response.data.data.dataAtualizacao, true) : 
                                                null);

                this.form.empresaId = response.data.data.empresa.id;


                

            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });

        },

        fetchTemas: function(){
            this.$store.dispatch(START_LOADING);
            InfosService.buscarTemas().then(response => {
                this.options.temas = response.data.data.map(el => { return {value: el.id, text: el.nome} }).sort((a,b) => {
                    if(b.text == 'Outros') return -1;
                    if (a.text < b.text) {
                        return -1;
                    }
                    if (a.text > b.text) {
                        return 1;
                    }
                    return 0;
                });
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        },
        fetchSubtemas: function(){
            this.$store.dispatch(START_LOADING);
            InfosService.buscarSubtemas().then(response => {
                this.options.subtemas = response.data.data.map(el => { return {value: el.id, text: el.nome} }).sort((a,b) => {
                    if (a.text < b.text) {
                        return -1;
                    }
                    if (a.text > b.text) {
                        return 1;
                    }
                    return 0;
                });
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        },
    },
    mounted(){
        
        this.$store.dispatch(DEFINIR_BREADCRUMB, [
            {titulo : "Banco de demandas", to: {name: "demanda-lista"}},
            { titulo: (this.id ? "Editar" : "Cadastrar") }
        ]);

        this.fetchTemas();
        this.fetchSubtemas();

        if(this.id)
            this.fetchDemanda(this.id);
        
    },
    computed: {
        permissao() {
            return this.$store.getters['app/retornaPermissao']('BancoDemanda');
        },
        selectedCompany() {
            return this.$store.state.app.selectedCompany;
        },
    }
}
</script>

<style>
    
</style>